module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-6-1842ea81a1fb9fc3f0261738918d6bd1.jpg";